import { Input } from "antd";
import { message } from 'antd';
import { CopyOutlined } from "@ant-design/icons";
import { useParams } from 'react-router-dom'
// import "antd/dist/antd.css";

export const ShareInput = ({ contentToggle, privacy }) => {
  const { id } = useParams();
  const sharedUrl = `https://board.workw.com${privacy === 0 ? "/external" : ""}/${id}`;
  const copyLinkIcon = <CopyOutlined onClick={() => { navigator.clipboard.writeText(sharedUrl); message.success("Link copied to clipboard") }} />;
  return (
    <>
      {contentToggle ? (
        <Input placeholder="Add people and groups" />
      ) : (
        <Input size="small" suffix={copyLinkIcon} value={sharedUrl} />
      )}
    </>
  );
};
